import React, { useState, useEffect } from "react"
import {
    Provider,
    defaultTheme,
    Flex,
    View,
    Heading,
    Text,
    Button,
    Divider,
    Content,
} from "@adobe/react-spectrum"
import Checkmark from "@spectrum-icons/workflow/Checkmark"
import {
    SERVER_URL,
    IHUB_URL,
    ALERT_SERVER_URL,
    notify,
} from "../constants/constants"
import { getUserInfo, alertTokenApi } from "../utilities/api/userInfo"

const CheckIcon = () => (
    <span style={{ color: "#26890C", marginRight: 8 }}>
        <Checkmark size="XS" />
    </span>
)

const NewLogin = () => {
    // const [deviceScale, setDeviceScale] = useState(1);

    // useEffect(() => {
    //   const updateScale = () => {
    //     const pixelRatio = window?.devicePixelRatio || 1;
    //     setDeviceScale(pixelRatio);
    //   };

    //   updateScale();
    //   window.addEventListener('resize', updateScale);
    //   return () => window.removeEventListener('resize', updateScale);
    // }, []);

    // const getTransform = () => {
    //   const baseScale = 1.2;
    //   const inverseScale = baseScale / deviceScale;
    //   const calculatedScale = Math.max(0.6, Math.min(1.4, inverseScale));
    //   return `scale(${calculatedScale})`;
    // }

   

    const loginCarePortal = () => {
        try {
            location.href = `${SERVER_URL}/care/v1/session/login`
        } catch (error) {
            console.error("Error logging in:", error)
        }
    }

    const iHubLogin = () => {
        window.open(`${IHUB_URL}`, "_blank")
    }

    return (
        <Provider theme={defaultTheme} colorScheme="light">
            {/* <div
        style={{
          width: '100vw',
          backgroundColor:"#E4E4E4",  
          overflow: 'hidden',
        }}
      > */}
            {/* Header */}
            {/* <View backgroundColor="static-black" paddingY="size-200" paddingX="size-400">
          <Flex alignItems="center" gap="size-200">
            <img src="/Adobe Logo.svg" alt="Adobe Logo" style={{ height: 40, width: 'auto', marginRight: 16 }} />
            <Heading level={3} marginBottom={0} UNSAFE_style={{ color: 'white', fontWeight: 500 }}>Care for Customer Interactions</Heading>
          </Flex>
        </View> */}

            <Flex
                alignItems="center"
                justifyContent="center"
                height="calc(100vh - 68px)"
                UNSAFE_style={{ backgroundColor: "#E4E4E4",}}
            >
                <View UNSAFE_style={{backgroundColor:"white",padding:"20px 20px", borderRadius:"32px" ,boxShadow:"0px 3px 24px #59595952"}}>
                    <Flex
                        direction={{ base: "column", L: "row" }}
                        gap="size-400"
                    >
                        {/* Left Side - Image */}
                        <View
                            flex={1}
                            alignSelf="center"
                            justifySelf="center"
                            UNSAFE_style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                            }}
                        >
                            <img
                                src="/Left Image.png"
                                alt="Customer service team working together"
                                style={{
                                    borderRadius: "16px",
                                    objectFit: "cover",
                                    height: 550,
                                    width: 540,
                                    maxWidth: 540,
                                    maxHeight: 550,
                                }}
                            />
                        </View>
                        {/* Right Side - Login Sections */}
                        <Flex direction="column" gap="size-200" flex={1}>
                            <Heading
                                level={2}
                                UNSAFE_style={{
                                    fontWeight: 700,
                                    color: "#18181b",
                                    marginTop: 0,
                                }}
                            >
                                DX - Omnichannel Platforms
                            </Heading>

                            {/* Care Portal Section */}
                            <View
                                backgroundColor="gray-50"
                                borderRadius="large"
                                borderColor="gray-200"
                                borderWidth="thin"
                                padding="size-200"
                            >
                                <Flex>
                                    <img
                                        src="/Adobe Logo.svg"
                                        alt="Adobe Logo"
                                        style={{
                                            height: 40,
                                            width: 40,
                                            marginRight: 12,
                                            borderRadius: 8,
                                            padding: 6,
                                        }}
                                    />
                                    <Heading
                                        level={4}
                                        UNSAFE_style={{
                                            color: "#18181b",
                                            fontWeight: 600,
                                        }}
                                        marginBottom={0}
                                    >
                                        Care Portal
                                    </Heading>
                                </Flex>
                                <View marginBottom="size-200">
                                    <Flex direction="column" gap="size-50">
                                        <Flex alignItems="start">
                                            <CheckIcon />
                                            <Text>
                                                Manage user configurations and
                                                assign skilling/queues for
                                                Amazon Connect.
                                            </Text>
                                        </Flex>
                                        <Flex alignItems="start">
                                            <CheckIcon />
                                            <Text>
                                                Define smart routing rules and
                                                set routing criteria for better
                                                interaction flow.
                                            </Text>
                                        </Flex>
                                        <Flex alignItems="start">
                                            <CheckIcon />
                                            <Text>
                                                Configure notifications and
                                                Slack alerts for quick,
                                                actionable updates.
                                            </Text>
                                        </Flex>
                                        <Flex alignItems="start">
                                            <CheckIcon />
                                            <Text>
                                                Centralized self-service admin
                                                interface for streamlined
                                                management.
                                            </Text>
                                        </Flex>
                                    </Flex>
                                </View>
                                <Button
                                    variant="cta"
                                    width="100%"
                                    onPress={loginCarePortal}
                                    UNSAFE_style={{ cursor: "pointer" }}
                                >
                                    Login to Care Portal
                                </Button>
                            </View>
                            {/* Interaction Hub Section */}
                            <View
                                backgroundColor="gray-50"
                                borderRadius="large"
                                borderColor="gray-200"
                                borderWidth="thin"
                                padding="size-200"
                                UNSAFE_style={{ position: "relative" }}
                            >
                                <Flex >
                                    <img
                                        src="/Aic Icon.svg"
                                        alt="Interaction Hub Icon"
                                        style={{
                                            height: 45,
                                            width: 45,
                                            marginRight: 12,
                                            borderRadius: 8,
                                            padding: 6,
                                        }}
                                    />
                                    <Heading
                                        level={4}
                                        UNSAFE_style={{
                                            color: "#18181b",
                                            fontWeight: 600,
                                        }}
                                        marginBottom={0}
                                    >
                                        Interaction Hub
                                    </Heading>
                                </Flex>
                                <View marginBottom="size-200">
                                    <Flex direction="column" gap="size-50">
                                        <Flex alignItems="start">
                                            <CheckIcon />
                                            <Text>
                                                Omnichannel support: phone, chat
                                                and case channels.
                                            </Text>
                                        </Flex>
                                        <Flex alignItems="start">
                                            <CheckIcon />
                                            <Text>
                                                Web-based phone client
                                                (softphone).
                                            </Text>
                                        </Flex>
                                        <Flex alignItems="start">
                                            <CheckIcon />
                                            <Text>
                                                Manages customer interactions
                                                across all channels.
                                            </Text>
                                        </Flex>
                                        <Flex alignItems="start">
                                            <CheckIcon />
                                            <Text>
                                                Streamlined interface for
                                                handling communications.
                                            </Text>
                                        </Flex>
                                    </Flex>
                                </View>
                                <Button
                                    variant="accent"
                                    style="outline"
                                    width="100%"
                                    marginBottom="size-400"
                                    onPress={iHubLogin}
                                    UNSAFE_style={{ cursor: "pointer" }}
                                >
                                    Login to iHub
                                </Button>
                                <View
                                    UNSAFE_style={{
                                        position: "absolute",
                                        bottom: 0,
                                        left: 0,
                                        right: 0,
                                        backgroundColor: "#AD0955",
                                        color: "#fff",
                                        padding: "8px 12px",
                                        borderBottomLeftRadius: "12px",
                                        borderBottomRightRadius: "12px",
                                        fontWeight: 600,
                                        fontSize: "12px",
                                        textAlign: "center",
                                    }}
                                >
                                    <img
                                        src="/Amazon Connect Logo.svg"
                                        alt="Amazon Logo"
                                        style={{
                                            height: 20,
                                            width: 20,
                                            marginRight: 6,
                                        }}
                                    />
                                    Amazon Connect login is now available via
                                    iHub.
                                </View>
                            </View>
                        </Flex>
                    </Flex>
                </View>
            </Flex>
            {/* </div> */}
        </Provider>
    )
}

export default NewLogin
